<template>
	<div>
		<CModal title="Modifier la raison de litige" size="lg" :show.sync="showModal">
			<form
				ref="editForm"
				:action="`/api/complaint_reasons/${complaint.id}`"
				method="POST"
				axiosMethod="patch">
				<FormContent v-if="showModal" :complaint="complaint" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.editForm)">Modifier</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormContent from './ComplaintReasonForm';

	export default {
		name: 'EditComplaintReason',
		components: {
			FormContent,
		},
		data() {
			return {
				showModal: false,
				complaint: {},
			};
		},
		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Texte du ligite modifié avec succès !');
						this.showModal = false;
						this.$emit('refresh');
					}
				});
			},
		},
	};
</script>
